import { isObjectTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import PortalIdParser from 'PortalIdParser';
export const settingsManageUrl = portalId => {
  return `/settings/${portalId}/sales/forecasting/manage`;
};
export const getCreateWizardForecastTypeRedirectUrl = ({
  forecastTypeId,
  portalId,
  baseAppURL,
  location
}) => {
  const originalPathname = location === null || location === void 0 ? void 0 : location.pathname;
  const originalQueryParams = new URLSearchParams(location === null || location === void 0 ? void 0 : location.search);
  // Coming from settings -> redirect to forecasting app
  if (originalPathname !== null && originalPathname !== void 0 && originalPathname.includes('forecasting') && (originalPathname !== null && originalPathname !== void 0 && originalPathname.includes('settings') || originalPathname !== null && originalPathname !== void 0 && originalPathname.includes('create-forecast'))) {
    const newQueryParams = new URLSearchParams();
    if (forecastTypeId) {
      newQueryParams.set('forecast_type', forecastTypeId.toString());
      newQueryParams.set('continue_setup', 'true');
    }
    return `${baseAppURL}/forecasting/${portalId}/teams${forecastTypeId ? `?${newQueryParams.toString()}` : ''}`;
  }

  // Coming from forecasting -> update the forecast type id
  if (!(originalPathname !== null && originalPathname !== void 0 && originalPathname.includes('settings')) && originalPathname !== null && originalPathname !== void 0 && originalPathname.includes('forecasting') && forecastTypeId) {
    originalQueryParams.set('forecast_type', forecastTypeId.toString());
    originalQueryParams.set('continue_setup', 'true');
  }

  // Return the original URL (with possible query param updates)
  return `${baseAppURL}${originalPathname}?${originalQueryParams.toString()}`;
};
export const getCreateWizardForecastTypeGoalsUrl = ({
  forecastTypeId,
  portalId,
  baseAppURL,
  location
}) => {
  const goalsBaseURL = encodeURI(`${baseAppURL}/goals/${portalId}/create/1?goalType=sales_quota${forecastTypeId ? `&forecastType=${forecastTypeId}` : ''}&redirectUrl=`);
  return `${goalsBaseURL}${encodeURIComponent(getCreateWizardForecastTypeRedirectUrl({
    forecastTypeId,
    portalId,
    baseAppURL,
    location
  }))}`;
};
export const createLinkFromIdAndObjectType = (id, objectType) => {
  const prefix = isObjectTypeId(objectType) ? 'record/' : '';
  return id && objectType ? `/contacts/${PortalIdParser.get()}/${prefix}${objectType.toLowerCase()}/${id}/` : undefined;
};